import React from "react";
import { useAuth } from "../../../modules/auth";
import Detalles from "./detalles";
import DetallesTestimonio from "./detallesTestimonio";

function DetallesWrapper() {
  const currentUser = useAuth();

  return <Detalles currentUser={currentUser} />;
  //return <DetallesTestimonio currentUser={currentUser}/>;
}

export default DetallesWrapper;